export const referralRewards: Record<string, number | undefined> = {
  eur: 5000,
  jpy: 5000,
  usd: 5000,
} as const;
